@if (leaderboardEntry?.rankStatus !== RankStatusEnum.None) {
    <ion-icon name="checkmark-circle-outline" [class]="'rank-status-' + (leaderboardEntry.rankStatus | lowercase)" />
} @else if (leaderboardEntry.hasBonus) {
    <ion-icon name="checkmark-circle-outline" class="ion-color ion-color-success" />
} @else {
    <ion-icon name="close-circle-outline" class="ion-color ion-color-medium" />
}
